module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D06-clean-04c48ccd41e6c2d320ef60672004d901.png";